import { type CommentType, type Order } from '../../types/digital-branch-order.types';

export const getTotalProducts = (order: Order | Order[]) => {
	if (Array.isArray(order)) {
		return order.reduce(
			(orderAcc, singleOrder) => orderAcc + singleOrder.groups.reduce((groupAcc, group) => groupAcc + group.items.length, 0),
			0
		);
	}
	return order.groups.reduce((groupAcc, group) => groupAcc + group.items.length, 0);
};

export const getAlertType = (completed: number, total: number): 'success' | 'danger' | 'warning' => {
	if (completed === 0) {
		return 'danger';
	} else if (completed < total) {
		return 'warning';
	} else {
		return 'success';
	}
};

export const isSevenDaysOrLessAway = (requiredDate: Date): boolean => {
	const currentDate = new Date();
	const sevenDaysFromNow = new Date(currentDate.setDate(currentDate.getDate() + 7));
	return requiredDate <= sevenDaysFromNow;
};

export const isCommentType = (value: string): value is CommentType => {
	return value === 'printable' || value === 'non-printable';
};
